import { OrderItemDeliveryLabelPatchCommandStatusEnum } from "@/config/apiClient";
import { tolgee } from "@/providers/TranslationProvider";

export const getDeliveryLabelStatusOptions = () => [
  {
    id: OrderItemDeliveryLabelPatchCommandStatusEnum.Validated,
    label: tolgee.t(
      "modals.validateDeliveryLabel.deliveryLabelStatus.LABEL_VALIDATED"
    ),
    textValue: tolgee.t(
      "modals.validateDeliveryLabel.deliveryLabelStatus.LABEL_VALIDATED"
    ),
  },
  {
    id: OrderItemDeliveryLabelPatchCommandStatusEnum.Refused,
    label: tolgee.t(
      "modals.validateDeliveryLabel.deliveryLabelStatus.LABEL_REFUSED"
    ),
    textValue: tolgee.t(
      "modals.validateDeliveryLabel.deliveryLabelStatus.LABEL_REFUSED"
    ),
  },
];
